export function RowSelector({setRows}) {
    return (
        <div
            className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar">
            <div>
                <select
                    onChange={(e) => setRows(e.target.value)}
                    aria-controls="kt_customers_table"
                    className="form-select form-select-solid form-select-sm"
                >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
        </div>
    );
}